import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, admin = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-center">Se încarcă...</div>;
  if (!user) return <Navigate to="/autentificare" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
